<template>
    <!-- 定时跟踪设置 -->
    <div class="mute-box">
        <div class="top-box">
            <el-form-item label="评率开关" >
                <el-switch v-model="switchShow" @change="onOffTimeUpdateClick"></el-switch>
            </el-form-item>
            <el-form-item label="定位间隔" >
                <el-select v-model="optionValue" placeholder="请选择" @change="onOffTimeUpdateClick">
                    <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.name"
                    :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-button type="primary" @click='dialogClick '>新增</el-button>
        </div>
        <div class="Table-Bottom" v-show="switchShow">
            <el-table
                :header-cell-style="{background:'#fff',color:'#000', height:'40px', }"
                ref="multipleTable"
                :data="tableData"
                :cell-style="{'text-align':'center'}"
                tooltip-effect="dark"
                @selection-change="handleSelectionChange">
                <el-table-column
                prop="address"
                label="时间段"
                show-overflow-tooltip>
                <template #default="scope">
                    <span v-for=" item in JSON.parse(scope.row.day)" :key="item" v-if="scope.row.day" >
                        <span v-if="item == 1"> {{ '周一'  }}, </span>
                        <span v-if="item == 2"> {{ '周二'  }}, </span>
                        <span v-if="item == 3"> {{ '周三'  }}, </span>
                        <span v-if="item == 4"> {{ '周四'  }}, </span>
                        <span v-if="item == 5"> {{ '周五'  }}, </span>
                        <span v-if="item == 6"> {{ '周六'  }}, </span>
                        <span v-if="item == 7"> {{ '周日'  }}, </span>
                    </span>
                    <!-- <span v-else> {{ '永不'  }} </span> -->
                </template>
                </el-table-column>
                <el-table-column
                prop="address"
                label="开始时间"
                show-overflow-tooltip>
                <template #default="scope">
                    {{ scope.row.startTime }}
                    <!-- <el-input v-model="scope.row.value" ></el-input> -->
                </template>
                </el-table-column>
                <el-table-column
                prop="address"
                label="结束时间"
                show-overflow-tooltip>
                <template #default="scope">
                    <!-- <el-input v-model="scope.row.value2" ></el-input> -->
                    {{ scope.row.endTime }}
                </template>
                </el-table-column>
                <el-table-column
                prop="address"
                label="操作"
                show-overflow-tooltip>
                <template #default="scope">
                    <span @click="updateClick(scope.row)" class="update-title">修改</span>
                    <span @click="deleteClick(scope.row)" class="delete-title">删除</span>
                </template>
                </el-table-column>
            </el-table>
        </div>
        <!-- <el-button type="primary" class="bottom-but" @click="baocunclick">保存设置</el-button> -->
            <el-dialog
                v-model="dialogVisible"
                title="添加频率"
                width="30%"
                :before-close="handleClose"
                destroy-on-close
            >
                <div class="time-box">
                    <el-form-item label="时段" label-width="60px">
                        <el-time-picker
                            is-range
                            v-model="value1"
                            range-separator="至"
                            :format="'HH:mm'"
                            value-format="HH:mm"
                            start-placeholder="开始时间"
                            end-placeholder="结束时间"
                            placeholder="选择时间范围">
                        </el-time-picker>
                    </el-form-item>
                </div>
                <el-form-item label="" label-width="60px">
                    <el-checkbox-group v-model="checkedCities" @change="handleCheckedCitiesChange">
                        <el-checkbox v-for="city in cities" :label="city.value" :key="city.value">{{city.name}}</el-checkbox>
                    </el-checkbox-group>
                </el-form-item>
                    
                <template #footer>
                <span class="dialog-footer">
                    <el-button @click="handleClose">取消</el-button>
                    <el-button type="primary" @click="confirmClose">
                    确定
                    </el-button>
                </span>
                </template>
            </el-dialog>
    </div>
</template>

<script>
import { locationFrequency,locationFrequencyAdd,locationFrequencyDelete,locationFrequencyUpdate,onOffTimeUpdate } from '@/assets/api/zhongduan.js'


export default {
    components: {

    },
    data() {
        return {
            tableData: [],
            dialogVisible: false,
            value1: [],
            cities: [ 
                {
                    name: '周一',
                    value:1
                },
                {
                    name: '周二',
                    value:2
                },
                {
                    name: '周三',
                    value:3
                },
                {
                    name: '周四',
                    value:4
                },
                {
                    name: '周五',
                    value:5
                },
                {
                    name: '周六',
                    value:6
                },
                {
                    name: '周日',
                    value:7
                },
            ],
            checkedCities: [],
            options: [
                {
                    value:60,
                    name: '1分钟'
                },
                {
                    value:300,
                    name: '5分钟'
                },
                {
                    value:600,
                    name: '10分钟'
                },
                {
                    value:900,
                    name: '15分钟'
                },
            ],
            optionValue: '',
            switchShow: false,
            detailsTtem: {}
        };
    },
    created() {
        this.locationFrequencyClick()
    },
    mounted() {

    },
    methods: {
        dialogClick () {
            this.dialogVisible = true
            this.value1 = []
            this.checkedCities = []
            this.detailsTtem = {}
        },
        locationFrequencyClick () {
            let params = {
                imei :this.$route.query.iemi ,
            } 
            locationFrequency(params).then((res)=> {
                console.log(res,'定位评率列表');
                    this.tableData = res.data.data.times
                    this.switchShow = res.data.data.followingOnOff
                    this.optionValue = res.data.data.followingInterval
            }).catch((err) => {
                console.log(err);
            })
        },
        handleCheckedCitiesChange (value) {
            console.log(value,77899);
        },
        handleSelectionChange () {
            console.log(1111111111111);
        },
        handleClose () {
            this.dialogVisible = false
            this.value1 = []
            this.checkedCities = []
        },
        confirmClose () {
            if ( JSON.stringify(this.detailsTtem) != '{}' ) {
                this.locationFrequencyUpdateClick()
            } else {
                this.addClose()
            }
        },
        addClose () {
            let params = {
                days: this.checkedCities,
                imei:this.$route.query.iemi,
                startTime: this.value1[0],
                endTime: this.value1[1],
            }
            locationFrequencyAdd(params).then((res)=> {
                console.log(res,'新增');
                this.locationFrequencyClick()
                this.$message({
                    message: '新增成功！',
                    type: 'success'
                });
                this.dialogVisible = false
              
            }).catch((err) => {
                this.$message({
                    type: 'error',
                    message: err.response.data.msg
                });
            })
            console.log('新增',this.value1);
        },
        updateClick (item) {
            this.detailsTtem = item
            this.checkedCities =  JSON.parse(item.day)
            this.value1.push(item.startTime)
            this.value1.push(item.endTime)
            this.dialogVisible = true
            console.log( this.value1,item);
        },
        locationFrequencyUpdateClick () {
            let params = {
                days: this.checkedCities,
                id: this.detailsTtem.id ,
                startTime: this.value1[0],
                endTime: this.value1[1],
            }
            locationFrequencyUpdate(params).then((res)=> {
                console.log(res,'修改');
                this.locationFrequencyClick()
                this.$message({
                    message: '修改成功',
                    type: 'success'
                });
                this.dialogVisible = false
            }).catch((err) => {
                // console.log(err);
                this.$message({
                    type: 'error',
                    message: err.response.data.msg
                });
            })
        },
        deleteClick (item) {
            let params = {
                id: item.id,
            } 
            locationFrequencyDelete(params).then((res)=> {
                this.$message({
                    message: '删除成功！',
                    type: 'success'
                });
                this.locationFrequencyClick()
            }).catch((err) => {
                // console.log(err);
                this.$message({
                    type: 'error',
                    message: err.response.data.msg
                });
            })
        },
        onOffTimeUpdateClick () {
            let params = {
                imei:this.$route.query.iemi ,
                followingOnOff: this.switchShow,
                followingInterval: this.optionValue 
            } 
            onOffTimeUpdate(params).then((res)=> {
                this.$message({
                    message: '设置成功！',
                    type: 'success'
                });
                this.locationFrequencyClick()
            }).catch((err) => {
                // console.log(err);
                this.$message({
                    type: 'error',
                    message: err.response.data.msg
                });
            })
        },
    },
};
</script>

<style scoped lang="scss">
.mute-box{
    background-color: #fff;
    .top-box {
        margin-top: 15px;
    }
    /deep/{
        .el-form-item--small .el-form-item__label{
            font-size: 15px;
        }
    }
    .Table-Bottom {
        width: 620px; /*no*/
        border: 1px solid  #eee;
        margin-top: 20px;
        
        /deep/ {

            .el-input {
                width: 160px;
            }
            .el-table th.el-table__cell>.cell {
                text-align: center;
                font-size: 15px;
            }
            .el-select--small .el-select__wrapper{
                width: 250px;
            }
        }
    }
    .bottom-but {
        margin: 20px 0px;
        margin-left: 130px;
    }
    .time-box {
        width: 80%;
    }
    .delete-title {
        color: red;
        cursor: pointer;
        margin-left: 5px;
    }
    .update-title {
        color: #61affe;
        cursor: pointer;
    }
}
</style>
